<div class="common-text-input__container"
  [id]="field.id">
  <div class="common-text-input__container-box"
    [ngClass]="{'common-text-input__container-box--error': field.error}"
    [attr.disabled]="field.noEditable?true:null">
    <div class="common-text-input__block-header">
      <label class="common-text-input__label"
        [for]="'field-type-password-'+field.id">
        <span class="common-text-input__text-label">{{fieldTypePassword.titleField}}</span>
        @if(field.required){
          <span class="common-tag__mandatory-text-asterisk">*</span>
        }
        <div class="common-text-input__block-buttons">
          @if (field.description) {
            <tooltip-info [description]="field.description"
            [field]="field"></tooltip-info>
          }
          @if (field.references?.length) {
            <tooltip-law [references]="field.references"
            [field]="field"></tooltip-law>
          }
          <!-- @if (field.relatedInfo?.length) {
            <button class="common-button__icon-sm-noborder"
              pTooltip="{{'common.related-info'| afTranslate}}"
              tooltipPosition="top"
              (click)="openModalRelatedInfo(field.relatedInfo, $event)">
              <i class="lf-icon-search-text common-icon__md"></i>
            </button>
          } -->
        </div>
      </label>
      <div class="common-text-input__buttons-right-header">
        <button class="common-button__icon-sm-noborder"
          (click)="changeVisible()"
          [disabled]="field.noEditable">
          <i class="common-icon__md"
            [ngClass]="{'lf-icon-visible': !field.visible,
                'lf-icon-not-visible': field.visible}"></i>
        </button>
      </div>
    </div>
    <div class="common-text-input__block-input"
      [ngClass]="{'common-text-input__block-input--with-value': fieldTypePassword.inputText && !field.noEditable}">
      <input class="common-text-input__input"
        type="text"
        autocomplete="off"
        [id]="'field-type-password-'+field.id"
        [name]="'field-type-password-'+field.id"
        [maxlength]="field.maxLength?field.maxLength:null"
        [placeholder]="field.noEditable?'':placeholder"
        [disabled]="field.noEditable"
        [(ngModel)]="fieldTypePassword.inputText"
        (paste)="pasteTextInField($event)"
        (input)="inputHandle($event)"
        (blur)="changeInField()"/>
      @if(fieldTypePassword.inputText){
        <button class="common-text-input__icon-clean-input"
          (click)="resetInput()">
          <i class="lf-icon-close-thick common-icon__sm"></i>
        </button>
      }
    </div>
  </div>
  @if(field.error){
    <div class="common-text-input__mandatory-tag">
      @if(field.blocker){
        <i class="lf-icon-warning common-icon__error-md"></i>
      }
      @if (field.errorText) {
        <span>{{field.errorText}}</span>
      }@else {
        <span [afTranslate]="field.blocker?'common.field-mandatory-blocking':'common.field-mandatory'">Campo obligatorio</span>
      }
    </div>
  }
</div>
